function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m155.55 133.21c-13.59-6.75-27.02-23.89-31.17-29.73 7.35.58 21.47 7.39 29.35 7.39 26.78 0 46.42-27.67 94.3-10.56l-17.25-74.02a12.514 12.514 0 0 1 24.35-5.78l16.17 65.07.03-.01c32.68-10.86 56.25 11.27 79.71 17.91 26.15 7.39 51.34-2.93 51.92-3.16-.42.59-16.27 22.53-36.89 32.53q-2.505 1.215-4.98 2.23a93.186 93.186 0 0 1 -48.26 6.05 69.827 69.827 0 0 1 33.31 75.65c-5.91-5.29-15.12-17.62-23.47-21.35-10.35-4.61-36.95-7.71-55.89-36.46-6.8.22-9.6 33.97-39.19 40.5-7.6 1.68-32.83.23-37.89 4.58 3.27-33.97 32.66-41.81 22.21-68.02-5.54 1.92-30.6 9.93-56.34-2.81-.01 0-.01-.01-.02-.01z",
  fill: "#97c447"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m334.837 161.141c-2.773-.182-5.072-.457-6.787-.7a71.29 71.29 0 0 1 11.531 8.37 68.986 68.986 0 0 0 -4.744-7.67z",
  fill: "#7c993c"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m168.95 130.181c26.78 0 46.42-27.67 94.3-10.56l-17.25-74.021a12.487 12.487 0 0 1 11.574-15.258l-2.444-9.832a12.514 12.514 0 0 0 -24.35 5.78l17.25 74.02c-47.88-17.11-67.52 10.56-94.3 10.56-7.88 0-22-6.81-29.35-7.39a136.823 136.823 0 0 0 17.171 19.585c7.686 1.389 20.165 7.116 27.399 7.116z",
  fill: "#7c993c"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m361.3 135.59c66.03 33.37 110.67 97.15 110.67 170.35 0 107.73-96.69 195.06-215.97 195.06s-215.97-87.33-215.97-195.06c0-74.99 46.84-140.08 115.52-172.73.01 0 .01.01.02.01 25.74 12.74 50.8 4.73 56.34 2.81 10.45 26.21-18.94 34.05-22.21 68.02 5.06-4.35 30.29-2.9 37.89-4.58 29.59-6.53 32.39-40.28 39.19-40.5 18.94 28.75 45.54 31.85 55.89 36.46 8.35 3.73 17.56 16.06 23.47 21.35a69.827 69.827 0 0 0 -33.31-75.65 93.186 93.186 0 0 0 48.26-6.05z",
  fill: "#f43b3b"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m337.9 429.125c-119.28 0-215.97-87.33-215.97-195.06a180.117 180.117 0 0 1 29.856-99.019c-66.619 33.213-111.756 97.282-111.756 170.894 0 107.73 96.69 195.06 215.97 195.06 79.261 0 148.533-38.568 186.1-96.052a233.309 233.309 0 0 1 -104.2 24.177z",
  fill: "#d61d1d"
});

var _ref7 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.8
}, /*#__PURE__*/React.createElement("path", {
  d: "m140.522 434.46a5.986 5.986 0 0 1 -4.476-2 203.428 203.428 0 0 1 -20.949-27.9 6 6 0 0 1 10.186-6.345 191.276 191.276 0 0 0 19.711 26.245 6 6 0 0 1 -4.472 10z",
  fill: "#e9e9e9"
}));

var _ref8 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.8
}, /*#__PURE__*/React.createElement("path", {
  d: "m102.319 369.942a6 6 0 0 1 -5.672-4.047 184.1 184.1 0 0 1 .495-121.333 6 6 0 0 1 11.316 4 172.088 172.088 0 0 0 -.465 113.428 6.005 6.005 0 0 1 -5.674 7.956z",
  fill: "#e9e9e9"
}));

function SvgTomato(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTomato);
export default __webpack_public_path__ + "static/media/tomato.463ff6b5.svg";
export { ForwardRef as ReactComponent };